import React from "react";
//import "./Pages.css";
import DiscordWidget from '../components/DiscordWidget'
function Contact() {
  return (
    <div className="page-container">
      <h1>Contact Us</h1>
      <p>
        We'd love to hear from you! Whether you have a question, suggestion, 
        or just want to say hi, you can reach out to us:
      </p>
      <ul>
        <li>Email: support@vortexnetowrknew.co.uk</li>
        <li>Twitter: @k3chow1</li>
        <li>Discord: Join our community server!</li>
        <DiscordWidget></DiscordWidget>
      </ul>
    </div>
  );
}

export default Contact;
